export const DefaultTransactionContent = () => {
  const data = [
    {
      key: 'Tracing Code',
      value: '987863',
    },
    {
      key: 'Tracing Code',
      value: '987863',
    },
    {
      key: 'Tracing Code',
      value: '987863',
    },
    {
      key: 'Tracing Code',
      value: '987863',
    },
    {
      key: 'Tracing Code',
      value: '987863',
    },
    {
      key: 'Tracing Code',
      value: '987863',
    },
  ]

  return (
    <div>
      {data.map((element) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '12px 4px',
            borderTop: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          <span style={{ color: 'grey' }}>{element.key}</span>
          <span style={{ color: 'white' }}>{element.value}</span>
        </div>
      ))}
    </div>
  )
}
